import { render } from "./MuayThaiPage.vue?vue&type=template&id=4fce9517"
import script from "./MuayThaiPage.vue?vue&type=script&lang=js"
export * from "./MuayThaiPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__